import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ExecutionAction, ExecutionSnapshot, ExecutionSettlement } from "./model.ts";

export class ExecutionBrowserIo extends Context.Service<ExecutionBrowserIo, {
  readonly remember: (workspaceId: string, scopeIds: readonly string[]) => Effect.Effect<void>;
}>()("workerstation/frontend/ExecutionBrowserIo") {}
export interface ExecutionSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ExecutionSnapshot>>;
  readonly read: Effect.Effect<ExecutionSnapshot>;
  readonly settlements: Effect.Effect<{ readonly total: number; readonly recent: readonly ExecutionSettlement[] }>;
  readonly dispatch: (action: ExecutionAction) => Effect.Effect<void>;
}
export class ExecutionSessions extends Context.Service<ExecutionSessions, {
  readonly open: Effect.Effect<ExecutionSession, never, Scope.Scope>;
}>()("workerstation/frontend/ExecutionSessions") {}
